import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zrwupcn5v: FaireProductEntity = {
  token: "p_6zrwupcn5v",
  type: "product",
  name: "Hot Garlic Chili Crisp — Spicy (32oz) Food Service",
  brandToken: "b_qe6cjwf7wv",
  brandName: "Mama Teav's",
  imageUrl:
    "https://cdn.faire.com/fastly/9cc285aa939f465224eb03c7b8d252ad79725d724eb8405171d6396d2f1f47d7.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dec39cd12495e2cced3617f69005856e662dfb983cfa3281a02d81fd4b560a60.png",
    "https://cdn.faire.com/fastly/49484f59cda4f20a6ec35d2381811b70d56f2e4583df6823aa619b7502e0311b.webp",
    "https://cdn.faire.com/fastly/d376a96ab21c52f4b4d92e30d818d838cd22453af4d5f306ffe46c9b3d841991.jpeg",
  ],
  priceDollars: 45,
  description:
    "Elevate your menu with the ingredient your kitchen has been missing. Our 32oz food service–sized jars are crafted for restaurants, cafes, and hospitality kitchens that demand bold, consistent flavor at scale.\n\nAll natural and allergen free, our Hot Garlic Chili Crisp is as versatile as it is craveable — whether spread on sandwiches, stirred into sauces, or finished over a dish right before it hits the table.\n\nWhy carry it:\n\nFood service sizing built for high-volume kitchens and retail shelves\nAll natural, allergen free, clean label, no compromises!\nEndlessly versatile: spreads, sauces, finishing oil, and more\nA standout product your customers will come back for.\n\nGive your offerings the punch they deserve.",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:53.237Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
